import { omit } from 'lodash';
import type {
  ApproveInfluencerData,
  CreateInfluencerData,
  InfluencerParams,
  UpdateInfluencerData,
} from './index.d';
import { oliveApi } from '../index';

const url = `/admin/v1/influencers`;

export const createInfluencersApi = async (data: CreateInfluencerData) => {
  return await oliveApi.POST<any, any>(`${url}`, data);
};

export const getInfluencerListApi = async (params: InfluencerParams) => {
  return await oliveApi.GET<InfluencerParams, any>(`${url}`, {
    ...params,
  });
};

export const updateInfluencerByCharisIdApi = async (
  data: UpdateInfluencerData
) => {
  const { charisUserId, ...tempData } = data;
  return await oliveApi.PATCH<any, any>(`${url}/${charisUserId}`, tempData);
};

export const approveInfluencersApi = async (data: ApproveInfluencerData) => {
  const tmpData = omit(data, 'projectId');
  return await oliveApi.PATCH<any, any>(`${url}/${data.projectId}`, tmpData);
};
